import React from "react";
import { Grid } from "@material-ui/core";
import { IoTicket } from "react-icons/io5";
import ButtonCustom from "../../../features/ButtonCustom/ButtonCustom";
import { MdOutlineClear } from "react-icons/md";
import { BasketItem } from "../../models/BasketItem";
import BasketItemDetails from "./BasketItemDetails";

interface IProps {
  colorClass: string;
  itemBasket: BasketItem;
  onRemoveToBasket: () => void;
  isWide: boolean;
}

const BasketItemPanel: React.FC<IProps> = ({ colorClass, itemBasket, onRemoveToBasket, isWide }: IProps) => {
  const isListPrice = (item: BasketItem) => item.listPrice !== item.price;

  return (
    <Grid
      container
      spacing={1}
      className={"basket-item"}
      justifyContent={"center"}
      alignContent={"center"}
      alignItems={"center"}
    >
      <Grid item xs={isWide ? 1 : 2}>
        <span>
          <IoTicket className={`io-ticket ${colorClass}`} size={26} />
        </span>
      </Grid>
      {isWide ? (
        <BasketItemDetails itemBasket={itemBasket} />
      ) : (
        <Grid item xs={7} md={8} className={"basket-item-name"}>
          <p>{itemBasket.assortName}</p>
          <p>
            {isListPrice(itemBasket) && <span className={"list-price"}>{itemBasket.listPrice.toFixed(2)} zł</span>}{" "}
            {itemBasket.showPrice && (
              <span className={`${isListPrice(itemBasket) ? "red-class" : ""}`}>{itemBasket.price.toFixed(2)}zł</span>
            )}
          </p>
          <p>ilość: {itemBasket.qnt}</p>
          {Boolean(itemBasket.passCode) && <p>numer: {itemBasket.passCode}</p>}
        </Grid>
      )}
      <Grid item xs={2} md={1}>
        <ButtonCustom
          title={""}
          className={`button-remove`}
          Icon={MdOutlineClear}
          iconPosition={"center"}
          onClick={onRemoveToBasket}
        />
      </Grid>
    </Grid>
  );
};

export default BasketItemPanel;
